import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "./gameData";

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
    fixPivot(scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS), "EffectAnimations/", EffectAnimationData.frames);
    fixPivot(scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS), "Feed-Me-Fractions-Animations/", FeedMeFractionsAnimationData.frames);

    createAnimation(scene.anims, ABCyaPhaser.Images.DEFAULT_ATLAS, "effect1", EffectAnimationData.animations.effect1.frames, false);
    createAnimation(scene.anims, ABCyaPhaser.Images.DEFAULT_ATLAS, "effect2", EffectAnimationData.animations.effect2.frames, false);
    createAnimation(scene.anims, ABCyaPhaser.Images.DEFAULT_ATLAS, "effect3", EffectAnimationData.animations.effect3.frames, false);
    createAnimation(scene.anims, ABCyaPhaser.Images.DEFAULT_ATLAS, "effect4", EffectAnimationData.animations.effect4.frames, false);
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
    frameData.forEach((data, index) => {
        let frame = texture.get(prefix + index);
        frame.customPivot = true;
        frame.pivotX = data[5] / data[2];
        frame.pivotY = data[6] / data[3];
    });
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 * @param {string} texture 
 */
export function addAnimations(sprite, animation) {
    let animationData = null;
    switch (animation) {
        case "left_eye": animationData = FeedMeFractionsAnimationData.animations.left_eye.frames; break;
        case "right_eye": animationData = FeedMeFractionsAnimationData.animations.right_eye.frames; break;
        case "mouth_eat": animationData = FeedMeFractionsAnimationData.animations.mouth_eat.frames; break;
    }

    let frames = [];
    animationData.forEach(frameNum => frames.push({ frame: "Feed-Me-Fractions-Animations/" + frameNum.toString() }));
    sprite.anims.create(
        {
            defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
            frameRate: 24,
            key: animation,
            frames: frames
        });

    sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + animation, () => {
        switch (animation) {
            case "left_eye": sprite.setFrame("Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.left_eye_idle.frames[0].toString()); break;
            case "right_eye": sprite.setFrame("Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.right_eye_idle.frames[0].toString()); break;
            case "mouth_eat": sprite.setFrame("Feed-Me-Fractions-Animations/" + FeedMeFractionsAnimationData.animations.mouth_idle.frames[0].toString()); break;
        }
    });
}

/**
 * 
 * @param {Phaser.Animations.AnimationManager} animationManager 
 * @param {string} texture 
 * @param {string} key 
 * @param {number[]} animationData 
 */
function createAnimation(animationManager, texture, key, animationData, repeat) {
    let frames = [];
    animationData.forEach(frameNum => frames.push({ frame: "EffectAnimations/" + frameNum.toString() }));

    animationManager.create(
        {
            defaultTextureKey: texture,
            frameRate: 24,
            key: key,
            frames: frames,
            repeat: repeat ? -1 : undefined
        });
}

const EffectAnimationData = {
    frames: [
        [2044, 2, 0, 0, 0, 0, 0],
        [207, 1164, 181, 92, 0, -2, -46],
        [300, 1007, 181, 137, 0, -2, -24],
        [389, 265, 182, 182, 0, -1, -1],
        [1319, 265, 182, 182, 0, -1, -1],
        [1505, 265, 182, 182, 0, -1, -1],
        [1691, 265, 182, 182, 0, -1, -1],
        [947, 265, 182, 182, 0, -1, -1],
        [1133, 265, 182, 182, 0, -1, -1],
        [575, 265, 182, 182, 0, -1, -1],
        [374, 456, 182, 182, 0, -1, -1],
        [761, 265, 182, 182, 0, -1, -1],
        [188, 456, 182, 182, 0, -1, -1],
        [2, 456, 182, 182, 0, -1, -1],
        [189, 642, 181, 181, 0, -2, -2],
        [2, 642, 183, 181, 0, 0, -2],
        [1862, 456, 183, 181, 0, 0, -2],
        [1675, 456, 183, 181, 0, 0, -2],
        [1488, 456, 183, 181, 0, 0, -2],
        [1301, 456, 183, 181, 0, 0, -2],
        [559, 642, 182, 181, 0, -1, -2],
        [930, 456, 182, 181, 0, -1, -2],
        [745, 456, 181, 181, 0, -2, -2],
        [560, 456, 181, 181, 0, -2, -2],
        [1116, 456, 181, 181, 0, -2, -2],
        [374, 642, 181, 181, 0, -2, -2],
        [929, 642, 180, 180, 0, -2, -2],
        [745, 642, 180, 180, 0, -2, -2],
        [1113, 642, 184, 179, 0, -3, -3],
        [1301, 642, 183, 178, 0, -3, -3],
        [183, 827, 182, 176, 0, -4, -4],
        [1392, 827, 177, 168, 0, -8, -8],
        [580, 1164, 77, 81, 0, -108, -49],
        [784, 1164, 73, 77, 0, -112, -53],
        [861, 1164, 70, 73, 0, -115, -57],
        [1212, 1164, 68, 68, 0, -116, -61],
        [1284, 1164, 68, 68, 0, -116, -61],
        [1405, 1164, 61, 61, 0, -120, -65],
        [1530, 1164, 54, 56, 0, -123, -67],
        [1588, 1164, 47, 47, 0, -127, -72],
        [2006, 827, 39, 38, 0, -131, -76],
        [1685, 1164, 33, 33, 0, -134, -79],
        [1722, 1164, 25, 24, 0, -138, -83],
        [2023, 2, 17, 17, 0, -143, -87],
        [95, 1164, 108, 95, 0, -28, -53],
        [1473, 1007, 74, 110, 0, -26, -37],
        [1045, 1007, 83, 119, 0, -25, -27],
        [1243, 1007, 108, 118, 0, -29, -25],
        [1907, 1007, 122, 104, 0, -34, -26],
        [1084, 1164, 124, 68, 0, -35, -28],
        [661, 1164, 119, 79, 0, -36, -26],
        [1551, 1007, 120, 107, 0, -36, -19],
        [810, 1007, 107, 122, 0, -48, -21],
        [625, 1007, 87, 127, 0, -63, -20],
        [716, 1007, 90, 123, 0, -57, -22],
        [1132, 1007, 107, 119, 0, -38, -25],
        [1675, 1007, 120, 105, 0, -25, -38],
        [1488, 642, 179, 178, 0, 0, -5],
        [1010, 1164, 70, 70, 0, -57, -55],
        [392, 1164, 92, 92, 0, -46, -44],
        [1355, 1007, 114, 113, 0, -34, -34],
        [485, 1007, 136, 135, 0, -23, -23],
        [1708, 827, 157, 157, 0, -12, -12],
        [1671, 642, 179, 178, 0, -1, -1],
        [1854, 642, 177, 177, 0, -2, -2],
        [2, 827, 177, 176, 0, -2, -2],
        [369, 827, 175, 175, 0, -3, -3],
        [548, 827, 174, 174, 0, -3, -3],
        [726, 827, 173, 173, 0, -4, -4],
        [903, 827, 172, 172, 0, -5, -4],
        [1079, 827, 171, 171, 0, -5, -5],
        [1877, 265, 169, 170, 0, -6, -5],
        [2, 1007, 153, 153, 0, -14, -14],
        [159, 1007, 137, 137, 0, -22, -22],
        [921, 1007, 120, 121, 0, -31, -30],
        [1799, 1007, 104, 104, 0, -39, -38],
        [488, 1164, 88, 87, 0, -48, -47],
        [935, 1164, 71, 72, 0, -56, -55],
        [1470, 1164, 56, 56, 0, -64, -63],
        [1639, 1164, 42, 42, 0, -72, -70],
        [1195, 2, 58, 204, 0, -39, -85],
        [1399, 2, 51, 200, 0, -43, -81],
        [1454, 2, 47, 197, 0, -45, -76],
        [830, 2, 66, 230, 0, -23, -72],
        [900, 2, 62, 229, 0, -25, -67],
        [1080, 2, 111, 228, 0, 0, -61],
        [966, 2, 110, 229, 0, 0, -54],
        [704, 2, 122, 232, 0, 0, -48],
        [578, 2, 122, 235, 0, 0, -41],
        [434, 2, 140, 240, 0, 0, -33],
        [290, 2, 140, 246, 0, 0, -24],
        [146, 2, 140, 252, 0, 0, -16],
        [2, 2, 140, 259, 0, 0, -7],
        [1505, 2, 139, 194, 0, -1, -68],
        [1257, 2, 138, 202, 0, -2, -53],
        [1648, 2, 136, 193, 0, -4, -52],
        [250, 265, 135, 183, 0, -4, -50],
        [1254, 827, 134, 170, 0, -4, -48],
        [1869, 827, 133, 154, 0, -5, -46],
        [1573, 827, 131, 166, 0, -6, -31],
        [2, 265, 129, 187, 0, -7, -7],
        [1905, 2, 114, 188, 0, -22, -4],
        [1788, 2, 113, 188, 0, -23, -1],
        [135, 265, 111, 186, 0, -24, 0],
        [2, 1164, 89, 102, 0, -44, 0],
        [1356, 1164, 45, 64, 0, -46, 0]
    ],
    // NOTE: THESE ALL REPEAT
    animations: {
        effect2: {
            frames: [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                0,
                0,
                0
            ]
        },
        effect3: {
            frames: [44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57]
        },
        effect4: {
            frames: [
                80,
                81,
                82,
                83,
                84,
                85,
                86,
                87,
                88,
                89,
                90,
                91,
                92,
                93,
                94,
                95,
                96,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                0,
                0,
                0,
                0
            ]
        },
        effect1: {
            frames: [
                58,
                59,
                60,
                61,
                62,
                63,
                64,
                65,
                66,
                67,
                68,
                69,
                70,
                71,
                72,
                73,
                74,
                75,
                76,
                77,
                78,
                79
            ]
        }
    }
}

export const FeedMeFractionsAnimationData = {
    frames: [
        [615, 372, 150, 42, 0, -1, -33],
        [368, 2, 150, 73, 0, -2, -2],
        [674, 2, 149, 73, 0, -2, -7],
        [216, 2, 148, 74, 0, -2, -12],
        [522, 2, 148, 73, 0, -2, -18],
        [2, 195, 150, 64, 0, -2, -33],
        [462, 195, 148, 57, 0, -2, -35],
        [521, 263, 148, 50, 0, -2, -38],
        [217, 322, 149, 44, 0, -2, -40],
        [156, 372, 149, 43, 0, -2, -36],
        [769, 372, 150, 42, 0, -2, -33],
        [309, 372, 149, 43, 0, -2, -37],
        [2, 322, 148, 46, 0, -2, -40],
        [766, 195, 148, 55, 0, -2, -36],
        [156, 195, 150, 64, 0, -2, -33],
        [614, 195, 148, 57, 0, -2, -35],
        [217, 263, 148, 50, 0, -2, -38],
        [370, 322, 149, 44, 0, -2, -40],
        [462, 372, 149, 43, 0, -2, -36],
        [2, 372, 150, 43, 0, -2, -33],
        [829, 322, 149, 43, 0, -2, -37],
        [673, 263, 148, 46, 0, -2, -40],
        [2, 263, 148, 55, 0, -2, -36],
        [827, 2, 150, 64, 0, -2, -33],
        [310, 195, 148, 57, 0, -2, -35],
        [369, 263, 148, 50, 0, -2, -38],
        [523, 322, 149, 44, 0, -2, -40],
        [676, 322, 149, 43, 0, -2, -36],
        [2, 2, 210, 189, 0, -1, -1],
        [303, 419, 59, 28, 0, -1, -1],
        [240, 419, 59, 29, 0, -1, -1],
        [923, 372, 59, 38, 0, -1, -1],
        [154, 263, 59, 55, 0, -1, -1],
        [154, 322, 59, 44, 0, -1, -1],
        [2, 419, 59, 34, 0, -1, -1],
        [177, 419, 59, 29, 0, -1, -1],
        [366, 419, 59, 28, 0, -1, -1],
        [486, 419, 52, 26, 0, -1, -1],
        [542, 419, 52, 26, 0, -1, -1],
        [65, 419, 52, 33, 0, -1, -1],
        [918, 195, 52, 48, 0, -1, -1],
        [934, 263, 52, 39, 0, -1, -1],
        [121, 419, 52, 30, 0, -1, -1],
        [429, 419, 53, 26, 0, -1, -1],
        [598, 419, 52, 26, 0, -1, -1],
        [981, 2, 27, 14, 0, -1, -1],
        [825, 263, 105, 46, 0, -1, -1]
    ],
    animations: {
        right_eye: {
            //"next": "right_eye_idle",
            frames: [37, 38, 39, 40, 40, 41, 42, 43, 44, 37]
        },
        body: { frames: [28] },
        left_eye_idle: { frames: [29] },
        right_eye_idle: { frames: [37] },
        mouth_idle: { frames: [0] },
        teeth: { frames: [45] },
        feet: { frames: [46] },
        left_eye: {
            //"next": "left_eye_idle",
            frames: [29, 30, 31, 32, 32, 33, 34, 35, 36, 29]
        },
        mouth_eat: {
            //"next": "mouth_idle",
            frames: [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                0
            ]
        }
    }
}